export const SET_HDE_EXPORTS_ITEMS = 'SET_HDE_EXPORTS_ITEMS';
export const SET_HDE_EXPORTS_PAGINATION = 'SET_HDE_EXPORTS_PAGINATION';
export const SET_HDE_EXPORTS_FILTERS = 'SET_HDE_EXPORTS_FILTERS';

export default {
  /**
   * Save HDE exports data.
   *
   * @param {Object} state - Od map exports state.
   * @param {{ items: Array, totalItems: number }} data - Od map exports data to set
   */
  [SET_HDE_EXPORTS_ITEMS]: (state, { items, totalItems }) => {
    state.items = items;
    state.pagination.totalItems = totalItems;
  },

  /**
   * Save HDE exports pagination.
   *
   * @param {Object} state - Od map exports state.
   * @param {Object} pagination - Od map exports pagination.
   */
  [SET_HDE_EXPORTS_PAGINATION]: (state, pagination) => {
    state.pagination = pagination;
  },

  /**
   * Saves filters of HDE exports.
   *
   * @param {Object} state - Od map exports state.
   * @param {Object} filters - Filters to set.
   */
  [SET_HDE_EXPORTS_FILTERS]: (state, filters) => {
    state.filters = filters;
  },
};
